<script setup lang="ts">
import { PageProps } from '@/types'
import { Head, usePage } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

const { t } = useI18n()

const page = usePage<PageProps>()

defineProps<{
  email: string
  confirmUrl: string
}>()

const completed = computed(() => {
  return page.props.toasts?.some((toast) => toast.severity === 'success') ?? false
})
</script>

<template>
  <div>
    <Head :title="t('title')" />

    <AuthCard>
      <template #title>
        {{ t('title') }}
      </template>
      <template #content>
        <Message v-if="!completed" severity="warn" icon="pi pi-exclamation-triangle">
          <p>
            {{ t('description') }}
          </p>
        </Message>

        <div class="mt-8 flex flex-col gap-0">
          <label class="font-medium"> {{ t('email') }}: </label>
          <div>
            {{ email }}
          </div>
        </div>
      </template>

      <template v-if="!completed" #footer>
        <div class="flex justify-end gap-2">
          <Link :href="confirmUrl" method="post">
            <Button :label="t('unsubscribe')" severity="secondary" />
          </Link>

          <Link href="/">
            <Button :label="t('cancel')" />
          </Link>
        </div>
      </template>
    </AuthCard>
  </div>
</template>

<i18n>
{
  "en": {
    "title": "Unsubscribe from all emails",
    "description": "You are about to unsubscribe from all emails sent by FinEstHub. This action cannot be undone.",
    "email": "Email address",
    "unsubscribe": "Unsubscribe",
    "cancel": "Cancel"
  },
  "de": {
    "title": "Alle E-Mails abbestellen",
    "description": "Sie sind dabei, sich von allen E-Mails von FinEstHub abzumelden. Diese Aktion kann nicht rückgängig gemacht werden.",
    "email": "E-Mail-Adresse",
    "unsubscribe": "Abbestellen",
    "cancel": "Abbrechen"
  }
}
</i18n>
